<template>
    <div id="news-page">
        <section class="about_history_area section_gap append_gap">
            <div class="container">
              <div class="row">
                  <div class="col-md-3 d_flex align-items-center">
                      <div class="about_content " style="width:100%">
                          <h2 class="title title_color">最新消息<br></h2>
                          <div class="text-left">
                          <ol class="breadcrumb">
                              <li class="base" @click="clearFilterType()" style="cursor:pointer">所有消息</li>
                              <li class="active">{{ this.cateText }}</li>
                          </ol>
                      </div>
                      </div>
                      
                  </div>
                  <div class="col-md-9">
                      <div class="row">
                    <div class="col-lg-4">
                        <div :class="{ 'categories_post': true, 'active': cate === 'promotion' }" @click="triggerNewsType('promotion')">
                            <img src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="富杉晴-住宿優惠&活動">
                            <div class="categories_details">
                                <div class="categories_text">
                                    <div id="promotion"><h5>住宿優惠&活動</h5></div>
                                    <div class="border_line"></div>
                                    <p>Promotion & Events</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div :class="{ 'categories_post': true, 'active': cate === 'partnership' }" @click="triggerNewsType('partnership')">
                            <img src="../assets/news/photo-1574805240811-dff46ef88526.jpg" alt="富杉晴-合作優惠">
                            <div class="categories_details">
                                <div class="categories_text">
                                    <div id="partnership" ><h5>合作優惠</h5></div>
                                    <div class="border_line">Partnership</div>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div :class="{ 'categories_post': true, 'active': cate === 'localtour' }" @click="triggerNewsType('localtour')">
                            <img src="../assets/news/photo-1574834892631-f773d4c7f3e7.jpg" alt="富杉晴-在地活動">
                            <div class="categories_details">
                                <div class="categories_text">
                                    <div id="localtour"><h5>在地活動</h5></div>
                                    <div class="border_line"></div>
                                    <p>Local Tour</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                  </div>
              </div>
            </div>
        </section>  

        <!--================Blog Area =================-->
        <section class="blog_area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="blog_left_sidebar">
                            <article class="row blog_item" v-for="(news, index) in filterdNewsDataByCate" :key="index">
                               <div class="col-md-3">
                                   <div class="blog_info text-right">
                                        <div class="post_tag">
                                            <small>消息</small><br/>
                                            <small>{{ news.type_name }}</small>
                                        </div>
                                        <ul class="blog_meta list_style">
                                            <li><span>{{ news.publish_time }}<i class="lnr lnr-calendar-full"></i></span></li>
                                        </ul>
                                    </div>
                               </div>
                                <div class="col-md-9">
                                    <div class="blog_post">
                                        <img v-if="news.main_img" :src="news.main_img" :alt="news.title">
                                        <img v-else src="../assets/news/default-news-banner.jpg" alt="富杉晴最新消息">
                                        <div class="blog_details">
                                            <a @click.stop="goNewsDetailPage(news.news_id)"><h2>{{ news.title }}</h2></a>
                                            <p>{{ news.brief }}</p>
                                            <div @click.stop="goNewsDetailPage(news.news_id)" class="button_hover theme_btn_two">View More</div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                            <nav class="blog-pagination justify-content-center d-none">
                              <ul class="pagination">
                                  <li class="page-item">
                                      <a href="#" class="page-link" aria-label="Previous">
                                          <span aria-hidden="true">
                                              <span class="lnr lnr-chevron-left"></span>
                                          </span>
                                      </a>
                                  </li>
                                  <li class="page-item"><a href="#" class="page-link">01</a></li>
                                  <li class="page-item active"><a href="#" class="page-link">02</a></li>
                                  <li class="page-item"><a href="#" class="page-link">03</a></li>
                                  <li class="page-item"><a href="#" class="page-link">04</a></li>
                                  <li class="page-item"><a href="#" class="page-link">09</a></li>
                                  <li class="page-item">
                                      <a href="#" class="page-link" aria-label="Next">
                                          <span aria-hidden="true">
                                              <span class="lnr lnr-chevron-right"></span>
                                          </span>
                                      </a>
                                  </li>
                              </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="blog_right_sidebar">
                            <aside class="single_sidebar_widget popular_post_widget">
                                <h3 class="widget_title">熱門消息</h3>
                                <div class="media post_item" v-for="(hot, index) in filterdHotNewsData" :key="index">
                                    <img v-if="hot.main_img" :src="hot.main_img" :alt="hot.title" width=100 height=60>
                                    <img v-else src="../assets/news/default-news-banner.jpg" width=100 height=60 alt="富杉晴最新消息">
                                    <div class="media-body">
                                        <a @click.stop="goNewsDetailPageHot(hot.news_id)" style="cursor:pointer;"><h3>{{ hot.title }}</h3></a>
                                        <p>{{ hot.publish_time }}</p>
                                    </div>
                                </div>
                                <div class="br"></div>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--================Blog Area =================-->
    </div>
</template>
<script>
import axios from 'axios'
const pathheader = window.location.protocol

export default {
  name: 'news',
  data () {
    return {
      cate: '',
      newsData: []
    }
  },
  computed: {
    filterdHotNewsData () {
      return this.filterdNewsData.filter((nd, index) => {
        return nd.tophot === '1'
      })
    },
    filterdNewsData () {
      return this.newsData.sort((a, b) => {
        if (a.id > b.id) {
          return -1
        }
        if (a.id < b.id) {
          return 1
        }
      })
    },
    filterdNewsDataByCate () {
      if (this.cate === '') {
        return this.filterdNewsData
      }
      return this.filterdNewsData.filter(d => {
        return d.cate === this.cate
      })
    },
    cateText () {
      let text = '不分類'
      switch (this.cate) {
        case 'promotion':
          text = '住宿優惠&活動'
          break
        case 'partnership':
          text = '合作優惠'
          break
        case 'localtour':
          text = '在地活動'
          break
      }
      return text
    }
  },
  mounted () {
    console.log(this.$route.query)
    let query = this.$route.query || {}
    this.cate = query.cate || ''
    this.getNews()
  },
  methods: {
    getDate (fullDate) {
      var rule = /(\d{4})-(\d{2})-(\d{2})/
    //   var result = fullDate.exec(rule)
    //   console.log(result)
      return fullDate.replace(rule, '$3')
    },
    getMonth (fullDate) {
      var rule = /(\d{4})-(\d{2})-(\d{2})/
    //   var result = fullDate.match(rule)
      return fullDate.replace(rule, '$1, $2')
    },
    goNewsDetailPage (id) {
      this.$ga.event('news', 'click-one-news', 'news-' + id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    goNewsDetailPageHot (id) {
      this.$ga.event('news', 'click-hot-news', 'news-' + id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    getNews () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getNews', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        const res = response.data
        this.newsData = res.data
      })
      .catch((errorResponse) => {
        // console.log(errorResponse)
      })
    },
    triggerNewsType (type) {
      this.$ga.event('news', 'filter-news-type', 'news-type-' + type, 1)
      this.$router.push({ name: 'News', query: { cate: type } })
    },
    clearFilterType () {
      this.$ga.event('news', 'filter-news-type', 'news-type-all', 1)
      this.$router.push({ name: 'News' })
    }
  }
}
</script>
<style lang="scss" scoped>
#news-page {
  min-height: 100vh;
    .news-intro {
      padding: 20rem 2rem;
      background-image: url("../assets/news/bed-bedroom-bedsheet-2387753.jpg");
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
      .news-intro-desc {
        background-color: rgba(255, 255, 255, 0.8);
        padding: 20px 200px 20px 20px;
        max-width: 70%;
        margin: 0 auto;
        width: 800px;
      }
      .news-intro-title {
        position: absolute;
        top: 40px;
        width: 44px;
        right: 10%;
        background: darkseagreen;
        opacity: .9;
        color: #fff;
        padding: 40px 100px;
        text-emphasis-style: filled;
        font-weight: 400;
        border-bottom: 5px solid #fff;
        border-right: 5px solid #fff;
      }
      .container {
        position: relative;
      }
  }
  .news-list {
    padding: 5rem 0;
    .card {
      border-width: 0px;
      margin-bottom: 2rem;
      // background-color: transparent;
      cursor: pointer;
      border-radius: 3px;
      padding: 20px;
      box-shadow: 0 6px 15px rgba(62, 57, 107, 0.1);
      overflow: hidden;
      .row {
        height: 100%;
        .news-data, .news-img {
          height: 150px;
        }
      }
      &:nth-of-type(2n+1) .row {
        flex-direction: row-reverse;
      }
      .card-time {
        z-index: 2;
        text-align: center;
        background: white;
        strong {
          display: block;
          margin-bottom: -10px;
          font-size: 60px;
        }
      }
      .card-classify {
        // position: absolute;
        // bottom: 0px;
        // right: 0px;
        padding: 5px;
        background: #93c178;
        color: white;
        z-index: 2;
      }
      .card-block {
        height: 100%;
        overflow: hidden;
        background-color: white;
        position: relative;
        .card-text {
          height: 100px;
          overflow: hidden;
        }
      }
      &:after {
        content: '';
        width: 90%;
        height: 90%;
        border: 3px solid #93c178;
        background: transparent;
        // background-color: rgba(0,0,0,.9);
        position: absolute;
        right: 100%;
        top: 5%;
        transition: all .6s ease;
        z-index: 1;
      }
      &:hover {
        .card-block {
          .card-title, .card-text {
            position: relative;
          }
          * {
            // color: white;
            z-index: 2;
          }
        }
        &:after {
          right: 5%;
        }
      }
      .hidden {
        display: none;
      }
    }
    .card-block {
      overflow: auto;
    }
  }
  .news-img {
    display: none;
  }
  @media (min-width: 768px) {
    .news-img {
      display: block;
    }
    .card-img-top {
      color: #fff;
      width: 100%;
      height: 100%;
      z-index: 2;
      img {
        object-fit: contain;
        width: 100%;
        height: 200px;
        position: relative;
        top: 50%;
        display: block;
        transform: translateY(-50%);
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/News.vue